<h1>ChatGPT</h1>

<br>You do need to have a paid account to register MCP servers with <a href="https://chatgpt.com" target="_blank" rel="noopener">ChatGPT</a>.
<br>If you do not have a paid subscription but want to experience the integration you can setup <a routerLink="/claude">Claude Desktop</a> or <a routerLink="/copilot-vs-code">VS Code Copilot</a> integration instead.
<br>
<br>At the moment you need to enable developer mode to add a custom MCP server.
<br>To do that open Settings -> Apps & Connectors -> Advanced Settings and Enable Developer Mode.
<br>Press Back (or go to Settings -> Apps & Connectors) and Press Create button that appears after enabling developer mode.
<br>
<br>Fill in the details as follows:
<br><i>Name: Todoapp
<br>MCP Server URL: {{ url }}/mcp
<br>Authentication: OAuth</i>
<br>
<br>Notes: 
<br>As you can see ChatGPT MCP support is new and labeled as BETA. While testing I observed one problem: First todo was created twice for me sometimes :)
<video controls preload="none" poster="/chatgpt.jpg">
  <source src="https://apps1storage.blob.core.windows.net/todo-videos/ChatGPT.mp4" type="video/mp4">
  Your browser does not support the video tag.
</video>